module.exports = __webpack_public_path__ + "static/media/volunteer.51c403a8.png";